// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ApPricingAreaId } from './ApPricingAreaId'
import {
  ApPricingAreaNavigation,
  ApPricingAreaNavigationIcon,
} from './ApPricingAreaNavigation'
import { ApPricingAreaRoutes } from './ApPricingAreaRoutes'

const LazyApPricingComponent = lazy(() => import('./ApPricingArea'))

const ApPricingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyApPricingComponent />
  </SuspenseLoadingWrapper>
)

export const ApPricingArea = {
  id: ApPricingAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_PRICING,
  Icon: ApPricingAreaNavigationIcon,
  NavigationComponent: ApPricingAreaNavigation,
  route: {
    path: ApPricingAreaRoutes.route,
    component: ApPricingComponent,
  },
}
